module.exports.community = {
  vi: {
    title: 'Cộng đồng · Avalon',
    description:
      'Tìm người chơi Avalon và các trò suy luận xã hội khác. Tham gia cộng đồng, tìm Đội tiếp theo và cùng nhau chơi.',
    keywords: ['Avalon', 'Cộng đồng', 'Discord'],
  },
  en: {
    title: 'Community · Avalon',
    description:
      'Find players for Avalon and other social deduction games. Join a community, meet your next team, and play together.',
    keywords: ['Avalon', 'Community', 'Discord'],
  },
  ru: {
    title: 'Сообщество · Avalon',
    description:
      'Находите игроков для Авалона и других игр на социальную дедукцию. Присоединяйтесь к сообществам, знакомьтесь и играйте вместе.',
    keywords: ['Avalon', 'Сообщество', 'Discord'],
  },
  es: {
    title: 'Comunidad · Avalon',
    description:
      'Encuentra jugadores de Avalon y otros juegos de deducción social. Únete a una comunidad, conoce a tu próximo equipo y jugad juntos.',
    keywords: ['Avalon', 'Comunidad', 'Discord'],
  },
  pt: {
    title: 'Comunidade · Avalon',
    description:
      'Encontre jogadores de Avalon e outros jogos de dedução social. Entre em uma comunidade, conheça sua próxima equipe e joguem juntos.',
    keywords: ['Avalon', 'Comunidade', 'Discord'],
  },
  'zh-CN': {
    title: '社区 · Avalon',
    description: '寻找阿瓦隆和其他社交推理游戏的玩家。加入社区，结识队友，一起游戏。',
    keywords: ['Avalon', '社区', 'Discord'],
  },
  'zh-TW': {
    title: '社群 · Avalon',
    description: '尋找阿瓦隆和其他社交推理遊戲的玩家。加入社群，結識隊友，一起遊戲。',
    keywords: ['Avalon', '社群', 'Discord'],
  },
};
